import { observable } from "mobx";
import type { EntityValidationRules } from "../../../services/validationService";
import RefundsSearchFilter, { RefundsSearchFilterValidationRules } from "./refundsSearchFilter";

export default class PayGateRefundsSearchFilter extends RefundsSearchFilter {
  @observable arn?: string;
  @observable authorizedDate?: Date;
  @observable cardNumber?: string;
  @observable invoiceNumber?: string;
  @observable payGatePaymentIdent?: string;
  @observable terminalId?: string;
}

export const PayGateRefundsSearchFilterValidationRules: EntityValidationRules<PayGateRefundsSearchFilter> = {
  ...RefundsSearchFilterValidationRules,
  arn: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  invoiceNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  payGatePaymentIdent: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  terminalId: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
};
